import users from '@/apis/modules/users'
import statistics from '@/apis/modules/statistics'
import qrcode from '@/apis/modules/qrcode'
import project from '@/apis/modules/project'
import projectUsers from '@/apis/modules/projectUsers'
import myInvitation from '@/apis/modules/myInvitation'

const api = {
  // 登录、用户、权限
  ...users,
  // 统计相关
  ...statistics,
  // 二维码相关
  ...qrcode,
  // 项目相关
  ...project,
  // 用户管理相关
  ...projectUsers,
  // 成员管理相关
  ...myInvitation,
}

Object.freeze(api)
export default api
